import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { useParams } from 'react-router';
import { HashLink } from 'react-router-hash-link';
import { projects } from '../../../Data/projects';
import ExtraImg from './ExtraImg/ExtraImg';
import LinksBtn from './LinksBtn/LinksBtn';
import './ProjectDetails.css';
const ProjectsDetails = () => {
    const { i } = useParams();
    const project = projects[i];

    // Open the page from the top instead of keeping the home page's scroll position
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [i]);

    if (!project) {
        return (
            <div className="project-detail-page project-not-found">
                <h2 className="jsectionHead">Project not found</h2>
                <HashLink to='/#projects-section' className="jbutton">Back to projects</HashLink>
            </div>
        );
    }

    const { name, img, desc, features = [], technologies = [], extraImages = [], links = {} } = project;

    return (
        <div className="project-detail-page">
            <HashLink to='/#projects-section' className="back-link">&larr; Back to projects</HashLink>
            <div className="project-content-head">
                <div className="project-left">
                    <h2 className="jsectionHead">{name}</h2>
                    <div className="project-image">
                        <img src={img} alt={name} style={{ width: '100%' }} />
                    </div>
                </div>
                <div className="project-right">
                    <h2>Description:</h2>
                    <p>
                        {desc}
                    </p>
                </div>
            </div>
            <div className="project-more-content">
                <Grid container columnSpacing={4}>
                    {
                        features.length ?
                            <Grid item xs={12} md={6}>
                                <div className="features-section">
                                    <h2>Features:</h2>
                                    <ul>
                                        {
                                            features?.map((futr, index) => <li key={index}>{futr}</li>)
                                        }
                                    </ul>
                                </div>
                            </Grid>
                            : <></>
                    }
                    <Grid item xs={12} md={6}>
                        <div className="technologies-section">
                            {
                                technologies.length ?
                                    <>
                                        <h2>Technologies:</h2>
                                        <ul className="tech-list">
                                            {
                                                technologies?.map((tech, index) => <li key={index}>{tech}</li>)
                                            }
                                        </ul>
                                    </>
                                    : <></>
                            }
                        </div>
                    </Grid>
                </Grid>
            </div>
            {
                Object.keys(links).length ? <LinksBtn links={links} /> : <></>
            }
            {
                Object.keys(extraImages).length ?
                    <>
                        <div className="extra-images-section">
                            <h2>Screenshots</h2>
                            {
                                extraImages && <ExtraImg extraImages={extraImages} />
                            }
                        </div>
                    </> : <></>
            }
        </div>
    );
};

export default ProjectsDetails;
